import React, {Component} from "react";

/**
 * The single value that shown in header.
 * @returns {React.ReactNode} The single value of player profile header.
 */

const InformationItem = (props) => {
    const {title, value} = props;
    return (
        <div className="information-item">
            <div className="information-item--title"> {title} </div>
            <div className="information-item--value"> {value} </div>
        </div>
    )
};

/**
 * @deprecated You can render without need to inherit from this component.
 */
class InformationTabBase extends Component {
    render = () => {
        return (
            <div style={{width: '100%', height: '100%'}}>
                InformationTabBase
            </div>
        )
    };

    renderDivider = () => <div className="divider"/>;
}

InformationTabBase.InformationItem = InformationItem;
export default InformationTabBase;
